import { P2GText } from '@parcel2go/core-ui';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { ProductParcel, ProductService } from '../adapters/product-types';

type ProductSummaryHeaderContentProps = {
  parcels: ProductParcel[];
  service: ProductService;
};

export const ProductSummaryHeaderContent = ({ parcels, service }: ProductSummaryHeaderContentProps) => {
  const { t } = useTranslation(TranslationNamespaces.CHECKOUT);
  return (
    <P2GText>
      <Trans
        i18nKey="PRODUCT_ITEMS_TITLE"
        t={t}
        defaults="<0>{{count}}</0> Item(s) being sent with <0>{{service}}</0>"
        values={{ count: parcels.length, service: service.name }}
        components={[<P2GText colour="primary" fontWeight="bold" />]}
      />
    </P2GText>
  );
};
